import { ApiResourceBaseClass as r } from "./baseApiCalls.js";
const e = "widgets";
class o extends r {
  /**
   * Lists widget setups.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/api/v2/widgets`
   *
   * @returns {Promise<WidgetSetupList>} A list of widget setups.
   */
  getWidgetSetups = async () => {
    const { data: t } = await this.get(e);
    return t;
  };
  /**
   * Creates a widget setup.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/api/v2/widgets`
   *
   * @param {CreateWidgetSetupData} [data] - A partial widget setup.
   * @returns {Promise<WidgetSetupData>} The created widget setup.
   */
  createWidgetSetup = async (t) => {
    const { data: a } = await this.post(e, t);
    return a;
  };
  /**
   * Updates a widget setup.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/api/v2/widgets/{widgetId}`
   *
   * @param {string} [widgetId] - Id of the widget setup to update.
   * @param {UpdateWidgetSetupData} [data] - A partial widget setup.
   * @returns {Promise<WidgetSetupData>} The updated widget setup.
   */
  updateWidgetSetup = async (t, a) => {
    const { data: s } = await this.patch(
      `${e}/${t}`,
      a
    );
    return s;
  };
  /**
   * Fetches a widget setup.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/api/v2/widgets/{widgetId}`
   *
   * @param {string} [widgetId] - Id of the widget setup to update.
   * @returns {Promise<WidgetSetupData>} The widget setup.
   */
  getWidgetSetup = async (t) => {
    const { data: a } = await this.get(`${e}/${t}`);
    return a;
  };
  /**
   * Deletes a widget setup.
   *
   * HTTP Verb: `DELETE`
   * Endpoint URL: `/api/v2/widgets/{widgetId}`
   *
   * @param {string} [widgetId] - Id of the widget setup to delete.
   * @returns {Promise<void>} Returns noting.
   */
  deleteWidgetSetup = async (t) => {
    const { data: a } = await this.delete(`${e}/${t}`);
    return a;
  };
  /**
   * Adds an avatar picture to a widget setup.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/api/v2/widgets/{widgetId}/avatar`
   *
   * @param {string} [widgetId] - Id of the widget setup.
   * @param {File} [file] - The image to upload.
   * @returns {Promise<WidgetSetupData>} The updated widget setup.
   */
  uploadAvatar = async (t, a) => {
    const s = new FormData();
    s.append("avatar_file", a);
    const { data: n } = await this.post(
      `${e}/${t}/avatar`,
      s
    );
    return n;
  };
}
export {
  o as WidgetSetup
};
